import type { CollectionContextValue } from "src/types"

export const defaultCollectionContextValue: CollectionContextValue = {
  loaded: false,
  loading: true,
  loadedUntil: null,
  collectionKey: "",
}
